import { jsx } from 'react/jsx-runtime';
import LinkifyReact from 'linkify-react';
import { TextButton } from '@flex-design-system/fx';

function Linkify({ children, color, options, ...props }) {
  return /* @__PURE__ */ jsx(
    LinkifyReact,
    {
      ...props,
      options: {
        defaultProtocol: "https",
        target: "_blank",
        ref: `noopener`,
        render: (params) => renderLink({
          ...params,
          color
        }),
        ...options
      },
      children
    }
  );
}
const renderLink = ({
  attributes,
  color,
  content
}) => {
  return /* @__PURE__ */ jsx(TextButton, { elementType: "anchor", color, ...attributes, children: content });
};

export { Linkify as default };
//# sourceMappingURL=Linkify.mjs.map
